import {useField} from "formik";

const EmailField = (props) => {
    const [field] = useField(props);
    return (
        <input type="email" {...field} {...props} />
    );
};

export default EmailField;